(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["avalon-bundle-selector"] && !Shopify.designMode) return;
  try {
    /**
   * Keeps the product form's quantity in step with the selected bundle, so Add to cart and
   * Buy now use it. The quantity field stays in the form (the stepper is only hidden).
   * The main product price follows the selected bundle and counts to the new amount.
   */
  class AvalonBundleSelector extends HTMLElement {
    #frames = new WeakMap();
    #timers = new WeakMap();
    #motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

    connectedCallback() {
      this.addEventListener('change', this.#onChange);
      this.#sync(false);
    }

    disconnectedCallback() {
      this.removeEventListener('change', this.#onChange);
    }

    #onChange = (event) => {
      if (event.target.matches('.avalon-bundle-option__input')) this.#sync(true);
    };

    // Counts a formatted price from its current text to the new text. The new text decides the format
    // (symbol, separators, decimals); only the digits move.
    #animateText(element, nextText, animate) {
      cancelAnimationFrame(this.#frames.get(element));
      clearTimeout(this.#timers.get(element));

      const from = element.textContent.replace(/\D/g, '');
      const to = nextText.replace(/\D/g, '');
      if (!animate || this.#motionQuery.matches || !from || !to || from === nextText) {
        element.textContent = nextText;
        return;
      }

      const start = Number(from);
      const end = Number(to);
      const length = to.length;
      const duration = 600;
      const startTime = performance.now();

      const render = (value) => {
        // Slots that are not filled yet (the number is still shorter) are dropped with their separator
        const digits = String(Math.round(value)).padStart(length, '\u0000').slice(-length);
        let index = 0;
        element.textContent = nextText
          .replace(/\d/g, () => digits[index++])
          .replace(/\u0000[.,\s\u00a0]*/g, '');
      };

      const tick = (now) => {
        const progress = Math.min(1, (now - startTime) / duration);
        const eased = 1 - Math.pow(1 - progress, 3);
        render(start + (end - start) * eased);

        if (progress < 1) {
          this.#frames.set(element, requestAnimationFrame(tick));
        } else {
          element.textContent = nextText;
        }
      };

      this.#frames.set(element, requestAnimationFrame(tick));
      // Animation frames are paused in background tabs, so always finish on the final amount
      this.#timers.set(
        element,
        setTimeout(() => {
          cancelAnimationFrame(this.#frames.get(element));
          element.textContent = nextText;
        }, duration + 80)
      );
    }

    // The main product price follows the selected bundle. The crossed-out amount is created when the
    // product has no compare-at price of its own, so the price block would not render one.
    #syncPrice(selected, animate) {
      const price = this.closest('.shopify-section')?.querySelector('.product-details product-price');
      if (!price) return;

      const priceEl = price.querySelector('.price');
      if (priceEl && selected.dataset.price) this.#animateText(priceEl, selected.dataset.price, animate);

      let compareEl = price.querySelector('.compare-at-price');
      const wanted = selected.dataset.compare;

      if (!compareEl && wanted && priceEl) {
        const group = document.createElement('span');
        group.setAttribute('role', 'group');
        group.dataset.avalonCompare = '';
        group.innerHTML = '<span class="visually-hidden">Regular price&nbsp;</span><span class="compare-at-price"></span>';
        (priceEl.closest('[role="group"]') || priceEl).after(' ', group);
        compareEl = group.querySelector('.compare-at-price');
        compareEl.textContent = wanted;
        return;
      }

      if (!compareEl) return;

      const group = compareEl.closest('[role="group"]');
      if (wanted) {
        this.#animateText(compareEl, wanted, animate);
        group?.removeAttribute('hidden');
      } else {
        compareEl.textContent = '';
        group?.setAttribute('hidden', '');
      }
    }

    #sync(animate) {
      const selected = this.querySelector('.avalon-bundle-option__input:checked');
      const form = this.closest('.shopify-section')?.querySelector('form[action*="/cart/add"]');
      const field = form?.querySelector('[name="quantity"]');
      if (!selected || !field) return;

      this.#syncPrice(selected, animate);

      field.value = selected.dataset.quantity;
      field.dispatchEvent(new Event('input', { bubbles: true }));
      field.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  if (!customElements.get('avalon-bundle-selector')) {
    customElements.define('avalon-bundle-selector', AvalonBundleSelector);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["avalon-buy-now"] && !Shopify.designMode) return;
  try {
    /**
   * Sends the visitor straight to checkout with the variant and quantity currently
   * selected in the product form (falls back to the variant rendered with the page).
   */
  class AvalonBuyNow extends HTMLElement {
    connectedCallback() {
      this.querySelector('button')?.addEventListener('click', this.#onClick);
    }

    disconnectedCallback() {
      this.querySelector('button')?.removeEventListener('click', this.#onClick);
    }

    #onClick = () => {
      const form = this.closest('.shopify-section')?.querySelector('form[action*="/cart/add"]');
      const id = form?.querySelector('[name="id"]')?.value || this.dataset.variantId;
      const quantity = Number(form?.querySelector('[name="quantity"]')?.value) || 1;
      const root = this.dataset.cartRoot.replace(/\/$/, '');

      window.location.href = `${root}/${id}:${quantity}`;
    };
  }

  if (!customElements.get('avalon-buy-now')) {
    customElements.define('avalon-buy-now', AvalonBuyNow);
  }
  } catch(e) { console.error(e); }
})();

})();
